import  * as schema from 'yup';
import { LoginFormModel } from '../models/models';

export const formSchema = schema.object<Partial<Record<keyof LoginFormModel, schema.AnySchema>>>({
	userName: schema.string().required('general.mandatory_field').matches(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, 'authentication.invalid_email'),
	password: schema.string().required('general.mandatory_field')
});
